export default "__VITE_ASSET__DxnrZvik__"